import Accordion from 'accordion-js'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { markInitialised } from '../utils/dom'

gsap.registerPlugin(ScrollTrigger)

export default function initAccordion() {
	// MARK: Content Accordions
	const accordions = document.querySelectorAll('.accordion')

	accordions.forEach((container) => {
		if (!markInitialised(container, 'jsAccordion')) return

		container.accordion = new Accordion(container, {
			onOpen: function () {
				ScrollTrigger.refresh()
			},
			onClose: function () {
				ScrollTrigger.refresh()
			},
		})
	})
}
